import {createSlice} from '@reduxjs/toolkit' 



const preloader = createSlice({
    name:'type',
    initialState:{
        toggle:false,
        filePdf:''
    },
    reducers:{
        preloaderToggle(state,{payload}){
            state.toggle = payload
        },
        pdff(state,{payload}){
            state.filePdf = payload
        }
    },

})
export const {preloaderToggle,pdff} = preloader.actions
export default preloader.reducer